import { StatusOption } from '../../utils'

export enum EventTypeEnum {
  MONEY = 'MONEY',
  ACTIVITY = 'ACTIVITY',
  COURSE = 'COURSE',
  DISCIPLINE = 'DISCIPLINE',
  DIVERS = 'DIVERS',
  SUPERVISION = 'SUPERVISION',
  FA2E_NOT_WANTED = 'FA2E_NOT_WANTED',
  ACCOMODATION = 'ACCOMODATION',
  REPATRIATION = 'REPATRIATION',
  CLAIM = 'CLAIM',
  HEALTH = 'HEALTH',
  TRAVEL = 'TRAVEL'
}

export const eventTypeEnumMapping: Record<EventTypeEnum, StatusOption> = {
  [EventTypeEnum.HEALTH]: {
    label: 'Santé',
    variant: 'primary'
  },
  [EventTypeEnum.DISCIPLINE]: {
    label: 'Discipline',
    variant: 'primary'
  },
  [EventTypeEnum.ACCOMODATION]: {
    label: 'Hébergement / Nourriture',
    variant: 'primary'
  },
  [EventTypeEnum.COURSE]: {
    label: 'Cours',
    variant: 'primary'
  },
  [EventTypeEnum.ACTIVITY]: {
    label: 'Activités',
    variant: 'primary'
  },
  [EventTypeEnum.TRAVEL]: {
    label: 'Voyage',
    variant: 'primary'
  },
  [EventTypeEnum.MONEY]: {
    label: 'Argent',
    variant: 'primary'
  },
  [EventTypeEnum.DIVERS]: {
    label: 'Divers',
    variant: 'primary'
  },
  [EventTypeEnum.FA2E_NOT_WANTED]: {
    label: 'FA2E non voulu',
    variant: 'primary'
  },
  [EventTypeEnum.SUPERVISION]: {
    label: 'Encadrement',
    variant: 'primary'
  },
  [EventTypeEnum.REPATRIATION]: {
    label: 'Rapatriement',
    variant: 'warning'
  },
  [EventTypeEnum.CLAIM]: {
    label: 'Réclamation',
    variant: 'danger'
  }
}
